const PersonIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.00007 7.3516c1.51215 0 2.73811-1.48898 2.73811-3.32568 0-1.83674-.40256-3.325725-2.73811-3.325725-2.33562 0-2.73811 1.488985-2.73811 3.325725C3.262 5.86262 4.48793 7.3516 6.00007 7.3516zM11.1657 12.295c-.0506-3.19969-.4685-4.11141-3.66626-4.68855 0 0-.45021.57356-1.49937.57356s-1.49929-.57356-1.49929-.57356C1.33793 8.17725.894556 9.07548.836281 12.191c-.00474.2544-.006924.2677-.00779.2382.000165.0553.000412.1577.000412.3362 0 0 .761327 1.5347 5.171207 1.5347 4.40989 0 5.17129-1.5347 5.17129-1.5347 0-.1147.0001-.1945.0002-.2487-.0009.0183-.0027-.0171-.0059-.2217z"
        fill="currentColor"
      />
    </svg>
  )
}

export default PersonIcon
